<template>
  <div v-show='isActive' class="tabBody">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Tab',
      required: true
    },
    icon: {
      required: false,
      type: String
    }
  },
  data () {
    return {
      isActive: true
    }
  }
}
</script>

<style scoped>

  .tabBody{
    width: inherit;
  }
</style>